export default __webpack_public_path__ + "static/media/Websources_01.ae6f44c1.png";